import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../../../components/Navbar";
import Footer from "../../../components/Footer";
import ScreenNav from "../../components/SignUp/ScreenNav";
import Commment from "../../components/SelectDevice/Comments";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import MobileNav from "../../../components/address/MobileNav";
import Issues from "../../components/Issues/Issues";
import imageUrl from "../../../components/category/img/Featured icon(4).png";
import OtpVerificationModal from "./OtpVerificationModal"; // Ensure you import the modal component

function Signup() {
  const [emailOrPhone, setEmailOrPhone] = useState('');
  const [error, setError] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility
  const [email, setEmail] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  // Extract device data from the location state
  const { brand, model, value, purchaseDuration } = state || {};
  // console.log("this is test2", brand, model, value, purchaseDuration);
  const handleGoBack = () => {
    navigate(-1);
  };
  const handlePhoneChange = () =>{
    navigate("/care-flow/select-device")
  }

  const handleSubmit = async () => {
    if (!emailOrPhone) {
      setError('Please enter your email or phone.');
      return;
    }

    const options = {
      method: 'POST',
      url: `${process.env.REACT_APP_BACKEND_URL}:7002/auth-service/auth/send-otp`,
      params: { email: emailOrPhone },
      headers: { accept: '*/*' }
    };

    try {
      await axios.request(options);
      setEmail(emailOrPhone);
      setMobileNumber(emailOrPhone);
      setIsModalOpen(true); // Open the OTP modal
    } catch (error) {
      console.error('Failed to send OTP:', error);
      setError('Failed to send OTP. Please try again.');
    }
  };

  const handleVerifyOtp = async (otp) => {
    const options = {
      method: 'POST',
      url: `${process.env.REACT_APP_BACKEND_URL}:7002/auth-service/auth/verify-otp`,
      headers: { 'content-type': 'application/json', accept: '*/*' },
      data: { otp: otp, email: email }
    };

    try {
      const { data } = await axios.request(options);
      const authToken = data.acessToken; // Ensure you are using the correct field for the token

      // Store the token in localStorage
      localStorage.setItem('authToken', authToken);

      // Calculate care plan
      await calculateCarePlan(authToken);
      return { success: true };
    } catch (error) {
      console.error('Failed to verify OTP:', error);
      return { success: false };
    }
  };

  const calculateCarePlan = async (authToken) => {
    const categorySkuCode = sessionStorage.getItem('categorySkuCode');
    const brandSkuCode = sessionStorage.getItem('brandSkuCode');
    const modelSkuCode = sessionStorage.getItem('modelSkuCode');

    const options = {
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}:8070/master-service/care/calculate-form-category-brand-model`,
      params: {
        price: '1000', // Replace with actual price if needed
        categorySku: '101',
        modelSku: '113',
        brandSku: '101'
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
        'content-type': 'application/json',
        accept: '*/*'
      },
      data: {
        planName: 'Cyber Protection',
        description: 'Keep Your device Protect from the Cyber Frauds' // Fixed typo
      }
    };

    try {
      const { data } = await axios.request(options);
      navigateToCarePlan(authToken, data);
    } catch (error) {
      console.error('Failed to calculate care plan:', error);
      alert('Failed to calculate care plan. Please try again later.');
    }
  };

  const navigateToCarePlan = (authToken, carePlanData) => {
    navigate('/care-flow/estimated-price', { state: { carePlanData } });
  };

  const handleResendOtp = async () => {
    const options = {
      method: 'POST',
      url: `${process.env.REACT_APP_BACKEND_URL}:7002/auth-service/auth/send-otp`,
      params: { email: emailOrPhone },
      headers: { accept: '*/*' }
    };

    try {
      await axios.request(options);
    } catch (error) {
      console.error('Failed to send OTP:', error);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="bg-[#F9FAFB] sm:mx-[60px] pt-[16px] px-[30px] pb-[90px] min-h-[680px] rounded-b-[40px] ">
        <div>
          <Navbar />
        </div>
        <div className="lg:hidden flex justify-center items-center my-8">
          <MobileNav />
        </div>
        <button
          onClick={handleGoBack}
          className="hidden ml-[48px] my-[60px] px-4 mb-4 py-[6px] sm:flex items-center justify-center gap-2 bg-white border border-gray-300 rounded-md shadow-sm"
        >
          <span className="">
            <MdKeyboardArrowLeft />
          </span>
          <span className="font-bold whitespace-nowrap font-plus-jakarta-sans text-[14px] leading-[20px]">
            Go Back
          </span>
        </button>
        <div className="grid sm:grid-cols-6 grid-cols-1 justify-center">
          <div className="col-span-4 sm:ml-[48px] ">
            <div className="text-left">
              <h1 className="sm:text-4xl text-3xl font-plus-jakarta-sans text-[#101828] sm:text-center text-left lg:text-left font-bold leading-[44px] max-w-[300px] lg:max-w-[500px]">
                Sign up to continue
              </h1>
              <p className="text-gray-500 font-plus-jakarta-sans mt-[8px]">
                By signing up, you can view the order <br /> details, track and
                get prompt updates.
              </p>
            </div>
            <div className="mt-[32px] sm:mr-[32px] sm:max-w-[400px]">
              <div className="w-full flex flex-col items-start gap-4 p-6 bg-white border border-gray-300 rounded-lg">
                <div className="w-full flex flex-col gap-4">
                  <div className="flex flex-col gap-1">
                    <label className="text-[#344054] text-[14px] font-[500]">
                      Email
                    </label>
                    <input
                      type="text"
                      placeholder="Enter your email"
                      value={emailOrPhone}
                      onChange={(e) => setEmailOrPhone(e.target.value)}
                      className="w-full h-11 p-2 rounded-md border border-gray-300 placeholder-[#667085] text-[16px] leading-[24px] focus:outline-none"
                    />
                    {error && (
                      <p className="text-red-500 text-sm mt-2">{error}</p>
                    )}
                  </div>
                </div>
                <button
                  onClick={handleSubmit}
                  className="w-full h-11 flex items-center justify-center bg-yellow-400 text-black font-bold rounded-md mt-5 font-plus-jakarta-sans"
                >
                  Get Started
                </button>
              </div>
            </div>
          </div>
          <div className="col-span-2 sm:border-l sm:px-[42px]">
            <div className="lg:block hidden self-center mb-[-20px]">
              <ScreenNav />
            </div>
            <div className="pt-4 pb-8 border-b">
              <div className="flex flex-row justify-between sm:ml-12 lg:ml-0 mt-4">
                <p className="text-[#475467] font-[700] text-[14px] leading-[20px] font-grFont self-start">
                  Your Device
                </p>
                <button
                    onClick={handlePhoneChange}
                  className="text-[#B28F02] font-[700] text-[14px] leading-[20px] font-grFont cursor-pointer"
                >
                  Change
                </button>
              </div>
              <div className="mt-3">
              <Issues
                  title={brand || "Brand Name"}
                  brand={brand || "Brand Name"}
                  model={model || "Model Name"}
                  price={value || "Device Value"}
                  purchaseYear={purchaseDuration || "N/A"}
                />
              </div>
            </div>
            <Commment />
          </div>
        </div>
      </div>
      <div className="sm:mx-[50px]">
        <Footer />
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-30">
          <OtpVerificationModal 
            onClose={handleCloseModal} 
            email={email} 
            mobileNumber={mobileNumber} 
            onVerify={handleVerifyOtp} 
            onResend={handleResendOtp} 
          />
        </div>
      )}
    </div>
  );
}

export default Signup;
